import { Injectable, Injector } from '@angular/core';
import { TranslateService, TranslateStore, TranslateLoader, TranslateCompiler, TranslateParser, MissingTranslationHandler } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExtendedTranslateService extends TranslateService {


  // No default language: the server merges every culture over en-US, and naming one here would make
  // the constructor download en-US at startup, before the token exists, for every user.
  constructor(
    store: TranslateStore,
    loader: TranslateLoader,
    compiler: TranslateCompiler,
    parser: TranslateParser,
    missingTranslationHandler: MissingTranslationHandler
  ) {
    super(
        store,
        loader,
        compiler,
        parser,
        missingTranslationHandler,
        true,
        false,
        false,
        '' // the typings require a value; the constructor only acts on a truthy one
    );
  }

  override instant(key: string | string[], interpolateParams?: Object): string | any {
    const upperKey = typeof key === 'string' ? key.toUpperCase() : key.map(k => k.toUpperCase());
    return super.instant(upperKey, interpolateParams);
  }

  override get(key: string | string[], interpolateParams?: Object): Observable<string | any> {
    const upperKey = typeof key === 'string' ? key.toUpperCase() : key.map(k => k.toUpperCase());
    return super.get(upperKey, interpolateParams);
  }
}
